<div class="overview">
    <app-kpis class="KPI"></app-kpis>
    <app-city class="cities"></app-city>
    <app-bizzmine class="bizzmine"></app-bizzmine>
    <app-infos class="INFOS"></app-infos>
    <app-reminder class="reminder"></app-reminder>
</div>
